import { Component, OnInit, Input } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { IDashboardSaleActivity } from '../../interface/IDashboardSaleActivity';

@Component({
    selector: 'app-sales-activity',
    templateUrl: './sales-activity.component.html',
    styleUrls: ['./sales-activity.component.scss'],
    standalone: true
})
export class SalesActivityComponent implements OnInit {
  @Input() salesActivity: IDashboardSaleActivity[];

  constructor(private dashboardService: DashboardService) { }

  ngOnInit() {
  }

}
